'use strict';

/**
 * 一键快签 - 列表设置 弹窗
 * 2019-05-06
 * fanglijuan
 */
angular.module('appQuickSignListMapDetailModule', [])
    . controller('appQuickSignListMapDetailCtrl', ['$scope', '$q', '$state', '$modalInstance', '$filter', 'modalDialog', '$stateParams', '$element', '$validation', 'trsHttpService', 'obj', 'editingCenterAppService', 'editingCenterService', 'jsonArrayToStringService', 'appQuickSignService', 'trsspliceString',
        function($scope, $q, $state, $modalInstance, $filter, modalDialog, $stateParams, $element, $validation, trsHttpService, obj, editingCenterAppService, editingCenterService, jsonArrayToStringService, appQuickSignService, trsspliceString) {
            initStatus();
            initData();

            /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
            function initStatus() {
                $scope.status = {
                    modalTitle: '设置列表样式',
                    // channelName: itemInfo.CHNLNAME,
                    siteid: $state.params.siteid,
                    // channelid: itemInfo.CHANNELID,
                    // selectedArray: selectedArray,
                    pictureSize: {},
                };
                $scope.data = {
                    item: obj,
                    label: [{
                        name: '无',
                        value: '无',
                    }], // 标签
                    ISFOCUSIMAGE: 1,
                    listStyle: editingCenterAppService.initListStyle(),
                    listPicRatio: {
                        set: {
                            0: '',
                            1: '',
                            2: '',
                        },
                        practical: {
                            0: '1',
                            1: '1',
                            2: '1',
                        },
                    },
                    focusRatio: {
                        set: '',
                        practical: '1',
                    },
                    bigPicRtion: {
                        set: '', //  大图只需要设置的值不需要单独实际值，因为大图使用的是列表图的第一张
                    },
                    specZtPicRtion: {
                        set: '', // 窄图
                    },
                };
                $scope.list = {
                    ZB_GUID: obj.ZB_GUID,
                    hybaseid: obj.HYBASEID,
                    LISTPICS: [],
                    LISTSTYLE: 0,
                    LABEL: '',
                    TITLE: obj.DOCTITLE,
                    IsFocusImage: 1,
                    FOCUSIMAGE: '',
                    FocusImgTitle: '',
                    FocusImageDesc: '',
                    doc_PictureList: ''
                };
                $scope.params = {
                    typeid: 'zyzx',
                    serviceid: 'expressSignSearchAll',
                    modelid: 'detailData',
                    // userId: $stateParams.cruser,
                    guid: obj.GUID
                };
            }

            /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
            function initData() {
            // 初始化标签..
                // editingCenterAppService.initTag($scope.status.siteid).then(function(list) {
                //     $scope.data.label = angular.copy(list);
                //     $scope.list.LABEL = list.length == 0 ? '' : list[0].value;
                // });
                getCutPictureWidthHeight();
                // requestData();
            }

            /**
         * [getCutPictureWidthHeight description]获取图片编辑默认宽高
         * @return {[type]} [description]
         */
            function getCutPictureWidthHeight() {
                editingCenterService.querySettedPicSize('app').then(function (data) {
                    var pictureSizeArr = ['NEWSPICSIZE', 'FOCUSIMAGESIZE', 'NEWSBIGPICSIZE', 'NEWSZTPICSIZE'];
                    var pictureSizeObj = editingCenterAppService.resetPicSize(pictureSizeArr, data);
                    // 将返回来的值进行复制到本身控制器里显示
                    dealPictureSize(pictureSizeArr, pictureSizeObj);
                });
                // var params = {
                //     serviceid: 'mlf_appconfig',
                //     methodname: 'getPicsSize',
                //     objectid: $scope.status.siteid
                // };
                // trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                //     $scope.status.pictureSize = {
                //         NEWSPICSIZE: data.NEWSPICSIZE == '' || data.NEWSPICSIZE == undefined ? '100,100' : data.NEWPICSIZE,
                //         FOCUSIMAGESIZE: data.FOCUSIMAGESIZE == '' || data.FOCUSIMAGESIZE == undefined ? '100,100' : data.FOCUSIMAGESIZE,
                //         NEWSBIGPICSIZE: data.NEWSBIGPICSIZE == '' || data.NEWSBIGPICSIZE == undefined ? '100,100' : data.NEWSBIGPICSIZE,
                //         NEWSZTPICSIZE: data.NEWSZTPICSIZE == '' || data.NEWSZTPICSIZE == undefined ? '100,100' : data.NEWSZTPICSIZE,
                //     };
                // });
            }

            /**
         * [dealPictureSize description]处理图片返回的比例操作
         *
         * @param   {[type]}  pictureSizeArr  [pictureSizeArr description]
         * @param   {[type]}  pictureSizeObj  [pictureSizeObj description]
         *
         * @return  {[type]}                  [return description]
         */
            function dealPictureSize(pictureSizeArr, pictureSizeObj) {
                pictureSizeArr.forEach(function (value, item) {
                    $scope.status.pictureSize[value] = pictureSizeObj[value];
                });
                // 定制gulp
                $scope.data.listPicRatio.set = pictureSizeObj.ratio.NEWSPICSIZE;
                $scope.data.focusRatio.set = pictureSizeObj.ratio.FOCUSIMAGESIZE;
                $scope.data.bigPicRtion.set = pictureSizeObj.ratio.NEWSBIGPICSIZE;
                $scope.data.specZtPicRtion.set = pictureSizeObj.ratio.NEWSZTPICSIZE;
            }
        
            /**
             * [requestData description]请求列表数据
             *
             * @return  {[type]}  [return description]
             */
            function requestData() {
            // 来源为网站客户端渠道的稿件时，默认文章内的第一张图为列表图
            // if ($scope.data.item.SECTIONTYPE.indexOf('wz') > -1 || $scope.data.item.SECTIONTYPE.indexOf('app') > -1) {
            //     queryImg();
            // } else if ($scope.data.item.SECTIONTYPE.indexOf('video') > -1 || $scope.data.item.SECTIONTYPE.indexOf('audio') > -1 || $scope.data.item.SECTIONTYPE.indexOf('wx') > -1) { //微信、音频和视频稿件_封面图自动填充到列表图中去(附图)
            //     if ($scope.data.item.isFastdfsCover) { //如果大数据已经下载图片的则将其下载，否则直接显示为文字稿
            //         getCoverImg($scope.data.item.PICTURECOVER);
            //     }
            // }
                if ($scope.data.item.PICTURECOVER) {
                    let arr = $scope.data.item.PICTURECOVER.split('/');
                    $scope.list.LISTSTYLE = 0;
                    $scope.list.LISTPICS[0] = {
                        APPFILE: arr[arr.length - 1],
                        APPDESC: arr[arr.length - 1],
                        PERPICURL: $scope.data.item.PICTURECOVER
                    };
                }
            }

            /**
         * [getCoverImg 下载图片到采编]
         * @param  {[type]} url [description]
         * @return {[type]}     [description]
         */
            // function getCoverImg(url) {
            //     if (url == undefined) {
            //         return;
            //     }
            //     var params = {
            //         url: url,
            //     };
            //     trsHttpService.httpServer('/wcm/openapi/downloadpic', params, 'post').then(function(data) {
            //         $scope.list.LISTSTYLE = 0;
            //         $scope.list.LISTPICS[0] = {
            //             APPFILE: data.imgName,
            //             APPDESC: data.imgName,
            //             PERPICURL: data.imgSrc
            //         };
            //     });
            // }

            // function queryImg() {
            //     var params = {
            //         typeid: "zyzx",
            //         serviceid: "expressSignSearchAll",
            //         modelid: "getImgList",
            //         guids: $scope.list.ZB_GUID
            //     };
            //     trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            //         if (data.content.length > 0) {
            //             getCoverImg(data.content[0][$scope.list.ZB_GUID].IMAGEURLS[0].urlS);
            //         }
            //     });
            // }

            /**
             * [timeSign description]定时签发函数
             * @param  {[obj]} item [description]稿件具体信息
             * @return {[type]}      [description]
             */
            $scope.timeSign = function(item) {
                $validation.validate($scope.listMapDetailForm).success(function () {
                    var list = dealAttributeBeforeSave();
                    var obj2 = {
                        indexName: obj.indexName,
                        IsTiming: true,
                        channelid: obj.channelid,
                    };
                    var params1 = {
                        isNewDraft: true,
                        selectedArray: [obj],
                        serviceid: 'mlf_appquicksign',
                        methodname: 'timeQuickSignDoc',
                        isQuickSign: true,
                    };
                    $scope.loadingPromise = editingCenterService.draftTimeSinged(params1, undefined, true).then(
                        function (data) {
                            appQuickSignService.fetchFromBigData(obj2, obj, list).then(
                                function (item) {
                                    data.serviceid = 'mlf_appquicksign';
                                    data.ChnlDocIds = trsspliceString.spliceString(item.REPORTS, 'CHNLDOCID', ',');
                                    data.ObjectIds = trsspliceString.spliceString(item.REPORTS, 'METADATAID', ',');
                                    data.MetaDataIds = trsspliceString.spliceString(item.REPORTS, 'METADATAID', ',');
                                    data.selectedArray = item.REPORTS;
                                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), data, 'POST').then(function (data) {
                                        modalDialog.alertType('设置定时快签成功', '', 'success', false, function () {
                                            requestData();
                                            $modalInstance.close('success');
                                        });
                                    });
                                }
                            );
                        }
                    );
                }).error(function() {
                    editingCenterService.checkSaveError($scope.listMapDetailForm, $element, $scope); // 定位输入错的表单位置
                    modalDialog.alertType('请检查填写项', '', 'warning', false, function() {});
                });
                // var obj2 = {
                //     indexName: obj.indexName,
                //     IsTiming: true,
                //     channelid: obj.channelid,
                // };
                // $scope.loadingPromise = appQuickSignService.fetchFromBigData(obj2, obj, $scope.list).then(
                //     function (item) {
                //         var params = {
                //             selectedArray: item.REPORTS,
                //             isNewDraft: true,
                //             serviceid: 'mlf_appquicksign',
                //             methodname: 'timeQuickSignDoc',
                //             isQuickSign: true,
                //         };
                //         editingCenterService.draftTimeSinged(params, undefined, true).then(
                //             function (data) {
                //                 modalDialog.alertType('定时快签成功', '', 'success', false, function () {
                //                     $modalInstance.close('success');
                //                 });
                //             }
                //         );
                //     }
                // );
            };
            
            /**
         * [deleteUploaderImg description]删除上传后的图片
         * @param  {[str]} attribute [description]要删除的属性
         * @param  {[num]} index     [description]下标
         * @return {[type]}           [description]
         */
            $scope.deleteUploaderImg = function(attribute, index) {
                if (attribute === 'LISTPICS') {
                    $scope.list[attribute][index] = {
                        'APPFILE': '',
                        'APPDESC': '',
                        'PERPICURL': ''
                    };
                } else {
                    $scope.list[attribute] = [];
                }
            };

            /**
         * [updateCKSelection description]trsCheckBox的回调函数
         * @param  {[str]} attribute [description]需要改变的属性
         * @return {[type]}           [description]
         */
            $scope.updateCKSelection = function(attribute) {
                $scope.list[attribute] = $scope.list[attribute] == 0 || $scope.list[attribute] == 'undefined' ? 1 : 0;
            };
            // 确定
            $scope.confirm = function() {
                $validation.validate($scope.listMapDetailForm).success(function() {
                    modalDialog.confirmModal('一键快签', '确定快签已选择的稿件吗？', function() {
                        // var jsonObj = {};
                        var list = dealAttributeBeforeSave();
                        var obj2 = {
                            indexName: obj.indexName,
                            IsTiming: false,
                            channelid: obj.channelid,
                        };
                        $scope.loadingPromise = appQuickSignService.fetchFromBigData(obj2, obj, list).then(
                            function (data) {
                                var params = {
                                    serviceid: 'mlf_appquicksign',
                                    methodname: 'quickSignDoc',
                                    ChnlDocIds: trsspliceString.spliceString(data.REPORTS, 'CHNLDOCID', ','),
                                };
                                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                                    modalDialog.alertType('快签成功', '', 'success', false);
                                    $modalInstance.close('success');
                                });
                            }
                        );
                    });
                }).error(function() {
                    editingCenterService.checkSaveError($scope.listMapDetailForm, $element, $scope); // 定位输入错的表单位置
                    modalDialog.alertType('请检查填写项', '', 'warning', false, function() {});
                });
            };

            /**
         * [dealAttributeBeforeSave description]保存前处理保存属性
         * @return {[obj]} [description]list对象
         */
            function dealAttributeBeforeSave() {
            // 根据列表样式过滤多余的图片信息
                if ($scope.list.LISTSTYLE == '2') {
                    $scope.list.LISTPICS = [];
                } else if ($scope.list.LISTSTYLE == '0') {
                    $scope.list.LISTPICS = [].concat(angular.copy($scope.list.LISTPICS[0]));
                }
                reWriteImg();
                var list = angular.copy($scope.list);
                list.LISTPICS = angular.copy(jsonArrayToStringService.clearEmptyArray(list.LISTPICS)); // jsonArrayToStringService.clearEmptyArray(list.LISTPICS)
                list.FOCUSIMAGE = angular.copy(jsonArrayToStringService.clearEmptyArray(list.FOCUSIMAGE));
                list = jsonArrayToStringService.jsonArrayToString(list);
                return list;
            }

            /**
         * [reWriteImg description]回写图片列表数据
         * @return {[type]} [description]
         */
            function reWriteImg() {
                var imgArray = ['FOCUSIMAGE', 'LISTPICS', 'FIGURE'];
                angular.forEach(imgArray, function(data, index) {
                    if ($scope.list[data] !== 0) {
                        var arrayDocPic = [];
                        angular.forEach($scope.list[data], function(dataC, indexC) {
                            arrayDocPic.push({
                                'APPFILE': dataC.APPFILE,
                                'APPDESC': dataC.APPDESC,
                                'PERPICURL': dataC.PERPICURL
                            });
                        });
                        $scope.list[data] = arrayDocPic;
                    }
                });
            }

            /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        }
    ]);
